import './App.css';
import MainPage from './views/MainPage/MainPage.jsx'
import "./style/index.scss";

function App() {
  return (
    <div className="App">
      <MainPage />
    </div>
  );
}

export default App;
